import { jsx as _jsx } from "react/jsx-runtime";
import { FlagsProvider } from 'flagged';
import { ThemeProvider } from 'styled-components';
import { PromotionsProvider } from './context/promotions-context';
import useServiceFile from './hooks/use-service-file';
import theme from './styles/theme';
import Promotions from './ui/promotions';
import { StyledCard } from './ui/promotions/subcomponents';
const PromotionsMFE = ({ accountId, accountIdType = 'guid', config }) => {
    var _a;
    const { data: serviceFileData } = useServiceFile({
        config
    });
    return (_jsx(ThemeProvider, { theme: theme, children: _jsx(FlagsProvider, { features: (_a = serviceFileData === null || serviceFileData === void 0 ? void 0 : serviceFileData.config) === null || _a === void 0 ? void 0 : _a.flags, children: _jsx(PromotionsProvider, { currentLanguage: config.lang, children: _jsx(StyledCard, { children: _jsx(Promotions, { accountId: accountId, accountIdType: accountIdType, config: config }) }) }) }) }));
};
export { default as Promotions } from './ui/promotions';
export default PromotionsMFE;
//# sourceMappingURL=index.js.map